module.exports = __webpack_public_path__ + "media/images/athletes/2877-510f122c7ef1d0e0eb2ca6d742769f5a.png";